import { render, staticRenderFns } from "./BasePagePreloader.vue?vue&type=template&id=b9d0a864&scoped=true&"
import script from "./BasePagePreloader.vue?vue&type=script&lang=ts&"
export * from "./BasePagePreloader.vue?vue&type=script&lang=ts&"
import style0 from "./BasePagePreloader.vue?vue&type=style&index=0&id=b9d0a864&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d0a864",
  null
  
)

export default component.exports